/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useMemo, useState } from 'react';
import type { U3401InitLU } from './U3401Service';

export interface U3401ContextType {
  initLU: U3401InitLU;
  setInitLU: React.Dispatch<React.SetStateAction<U3401InitLU>>;
}

const U3401Context = createContext<U3401ContextType | undefined>(undefined);

interface U3401ContextProviderProps {
  initLU: U3401InitLU;
  children: React.ReactNode;
}

export const U3401ContextProvider: React.FC<U3401ContextProviderProps> = ({
  initLU,
  children,
}) => {
  const [initLUState, setInitLU] = useState(initLU);

  const value = useMemo(
    () => ({
      initLU: initLUState,
      setInitLU,
    }),
    [initLUState],
  );

  return <U3401Context.Provider value={value}>{children}</U3401Context.Provider>;
};

export function useU3401Context(): U3401ContextType {
  const ctx = useContext(U3401Context);
  if (!ctx) {
    throw new Error('useU3401Context must be used within U3401ContextProvider');
  }
  return ctx;
}
